import React from 'react';
// ui
import { Typography } from 'rmwc/Typography';
import { Button, ButtonIcon } from 'rmwc/Button';

const RadioCumbria = () => {
    return (
        <div className={'app--page'}>

            <div className="app--page-content">
                <div className="app--section">

                    <Typography use={'headline4'} tag={'h1'}>
                        BBC Radio Cumbria WW1 at Home
                    </Typography>

                    <video width="100%" controls style={{ padding: '30px 0' }}>
                        <source src="./last-post.mp4" type="video/mp4"/>
                        <source src="./last-post.mp4" type="video/ogg"/>
                        Your browser does not support the video tag.
                    </video>

                    <Typography use={'body1'} tag={'p'}>
                        Radio Cumbria have a whole range of local WW1 stories from around the county on their site:
                    </Typography>
                       <Button tag={'a'}
                                              theme={'secondary-bg'}
                                              raised
                                              href={'https://www.bbc.co.uk/programmes/p01p33wp'}
                                              target={'_blank'}>
                        <ButtonIcon icon={'open_in_new'}/>
                        BBC WW1 at home
                    </Button>
                </div>
            </div>
        </div>
    )
};

export default RadioCumbria;


// WEBPACK FOOTER //
// ./src/app/pages/RadioCumbria.js